module.exports = __webpack_public_path__ + "media/images/img_plus-freelance-5fe88339c306d5a021b143de9a87938e.png";